const E_ADDRESS_CONFIRM = 'You must confirm the address';

export const validate = ({ selectedAddress }) => {
  var errors = {};

  if (!selectedAddress) {
    errors.address_confirm = E_ADDRESS_CONFIRM;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
